
import util from './util';

const deviceType = util.isPC() ? 'pc' : 'mobile';
const LOGURL = e => `${e}/tracker.1.0.gif?`;
const APLUS = (e) => {
  if (e.indexOf('alibaba.com') > -1) {
    return 'gm.mmstat.com';
  }
  return 'sg.mmstat.com';
};

let prefix = '';

let config = {};

const Log = {

  insSend(data, isImmediate = false) {
    // 判断如果是PC就不埋点
    // 设备类型 mobole:1 , desktop:2
    const img = new Image();
    const id = `img_${Math.random()}`;
    const param = data;
    const timestamp = new Date().getTime();
    let from = config.from || 'lazada';
    from = from || 'unknown';
    data.ext = data.ext || {};
    data.ext = data.ext;
    param._input_charset = 'utf-8';
    data.memberType = config.memberType;
    data.from = from;
    data.imsid = config.imsid;
    data.userId = config.userId;
    data.robotCode = config.robotCode;
    data.timestamp = timestamp;
    /**
     * 重要!!!!!!!!!!!!!!
     * 数据同学表示,字段顺序不要变,要加字段,在后面新增,不要改中间顺序
     */

    const src = `${LOGURL(prefix)}param=${JSON.stringify(data)}&biz=${deviceType}`;
    // 防止垃圾回收造成打点丢失
    window[id] = img;
    img.onload = img.onerror = () => {
      window[id] = null;
    };
    if (isImmediate) {
      img.setAttribute('src', src);
    } else {
      // 防止http请求造成操作卡顿
      setTimeout(() => {
        img.setAttribute('src', src);
      }, 500);
    }
  },

  send(data, isImmediate = false) {
     // 判断如果是PC就不埋点
    // 设备类型 mobole:1 , desktop:2
    const img = new Image();
    const id = `img_${Math.random()}`;
    const param = data;
    const timestamp = new Date().getTime();
    let from = config.from || 'lazada';
    from = from || 'unknown';
    data.ext = data.ext || {};
    data.ext = JSON.stringify(data.ext);
    param._input_charset = 'utf-8';

    /**
     * 重要!!!!!!!!!!!!!!
     * 数据同学表示,字段顺序不要变,要加字段,在后面新增,不要改中间顺序
     */
    const src = `//${APLUS(prefix)}/merobot.a2o35.8276445.${data.c}.${data.d}?cache=${timestamp}&ext=${data.ext}&memberType=${config.memberType}&from=${from}&imsid=${config.imsid}&autosend=1&userId=${config.userId}&robotCode=${config.robotCode}&deviceType=${deviceType}`;
    // 防止垃圾回收造成打点丢失
    window[id] = img;
    img.onload = img.onerror = () => {
      window[id] = null;
    };
    if (isImmediate) {
      img.setAttribute('src', src);
    } else {
      // 防止http请求造成操作卡顿
      setTimeout(() => {
        img.setAttribute('src', src);
      }, 500);
    }
    setTimeout(() => {
      this.insSend(data);
    }, 500);
  },

  perfLog(data) {
    if (window.performance && window.performance.now) {
      const time = performance.now();
      this.send({
        c: data.c,
        d: data.d,
        ext: JSON.stringify({
          time,
        }),
      }, true);
    }
  },

  setLog(data) {
    config = data;
  },
  getConfig() {
    return config;
  },
  setModel(e) {
    prefix = e;
  },
  liveAgent(e) {
    this.send({
      c: 'knowledge',
      d: 'gomanual',
      ext: e,
    });
  },

};

export default Log;



// WEBPACK FOOTER //
// ./src/lib/log.js